import { render, staticRenderFns } from "./NegativeBalanceTableBlock.vue?vue&type=template&id=2226edfa&scoped=true"
import script from "./NegativeBalanceTableBlock.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226edfa",
  null
  
)

export default component.exports